<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
                    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevoRegistro()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>
            {{DAT_TITULOS.tituloAgregar}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                     [pagination]="true"
                     [rowData]="rowData">
      [rowSelection]="'single'"
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModalAgregarItem'" [idClose]="'cerrarModalAgregarGarita'"
                [innTemplate]="abrirModalAgregarItem" [titulo]="tituloModal"></app-lfsa-modal>
<ng-template #abrirModalAgregarItem>
  <div class="container-fluid">
    <form [formGroup]="formulario" mat-dialog-content>
      <div class="row">
        <div *ngIf="!isCreate" class="mb-2">
          <label for="">ID</label>
          <input class="form-control" formControlName="id" id="id" name="id" readonly type="text">
        </div>
        <div class="col-12 col-md-6">
          <div class="mb-2">
            <label for="">Ingrese Cod. de Material</label>
            <input (change)="onChangeMaterial($event)" (keydown)="noWhitespace($event)"
                   (keyup)="onChangeMaterial($event);this.formulario.controls['mate'].value.length > 0 ? onChangeValues(): ''"
                   autocomplete="off" class="form-control is-invalid"
                   formControlName="mate"
                   id="mate" name="mate"
                   type="text">
            <div *ngIf="materialControl?.hasError('required') && materialControl.touched" class="text-danger">
              <small>*Este campo es requerido</small>
            </div>
            <div *ngIf="materialControl?.hasError('maxLength') && materialControl.touched" class="text-danger">
              <small>*Máximo 10 caracteres</small>
            </div>
            <div *ngIf="materialInvalido" class="text-danger mt-3">
              <small>*Este material es inválido</small>
            </div>
          </div>
        </div>
        <div class="form-group col-12 col-md-6">
          <app-lfsa-input [control]="this.formulario.get('desmat')" [id]="'desmat'" [isReadOnly]="true"
                          [label]="'Descripción del Material'"
                          formControlName="desmat" type="text"></app-lfsa-input>
        </div>
        <div class="form-group col-12 mb-3">
          <label for="">Nivel</label>
          <select (change)="onChangeValues();onChangeNivel()" class="form-control is-invalid" formControlName="nivel"
                  id="nivel">
            <option selected value="">-- Seleccione --</option>
            <option *ngFor="let data of cmbNivel" [value]="data.id">{{ data.desca }}</option>
          </select>
          <div *ngIf="formulario.controls['nivel'].invalid"
               class="text-danger mt-3">
            <small>
              <div *ngIf="formulario.controls['nivel'].errors">
                *El campo Nivel es requerido.
              </div>
            </small>
          </div>
        </div>
        <div class="form-group col-12 col-md-6">
          <app-lfsa-input (keypress)="keyDecimals($event)" [control]="this.formulario.get('acini')" [id]="'acini'"
                          [label]="'Acidez Inicial'"
                          formControlName="acini" placeholder="Ej: 1.2345"
                          type="number"></app-lfsa-input>
          <small *ngIf="this.formulario.get('acini')?.hasError('pattern')" class="letrasDanger">*Solo números y punto,
            hasta 4 decimales. Ej: 12.3456</small>
        </div>
        <div class="form-group col-12 col-md-6">
          <app-lfsa-input (keypress)="keyDecimals($event)" [control]="this.formulario.get('acifi')" [id]="'acifi'"
                          [label]="'Acidez Final'"
                          formControlName="acifi" placeholder="Ej: 1.2345"
                          type="number"></app-lfsa-input>
          <small *ngIf="this.formulario.get('acifi')?.hasError('pattern')" class="letrasDanger">*Solo números y punto,
            hasta 4 decimales. Ej: 12.3456</small>
        </div>
        <div class="form-group col-12 col-md-6">
          <app-lfsa-input (keypress)="keyDecimals($event)" [control]="this.formulario.get('humini')" [id]="'humini'"
                          [label]="'Hum + Imp Inicial'"
                          formControlName="humini" placeholder="Ej: 1.2345"
                          type="number"></app-lfsa-input>
          <small *ngIf="this.formulario.get('humini')?.hasError('pattern')" class="letrasDanger">*Solo números y punto,
            hasta 4 decimales. Ej: 12.3456</small>
        </div>
        <div class="form-group col-12 col-md-6">
          <app-lfsa-input (keypress)="keyDecimals($event)" [control]="this.formulario.get('humifi')" [id]="'humifi'"
                          [label]="'Hum + Imp Final'"
                          formControlName="humifi" placeholder="Ej: 1.2345"
                          type="number"></app-lfsa-input>
          <small *ngIf="this.formulario.get('humifi')?.hasError('pattern')" class="letrasDanger">*Solo números y punto,
            hasta 4 decimales. Ej: 12.3456</small>
        </div>
        <div class="form-group col-12 col-md-6">
          <app-lfsa-input (keypress)="keyDecimals($event)" [control]="this.formulario.get('pesini')" [id]="'pesini'"
                          [label]="'Peso Inicial'"
                          formControlName="pesini" placeholder="Ej: 1.2345"
                          type="number"></app-lfsa-input>
          <small *ngIf="this.formulario.get('pesini')?.hasError('pattern')" class="letrasDanger">*Solo números y punto,
            hasta 4 decimales. Ej: 12.3456</small>
        </div>
        <div class="form-group col-12 col-md-6">
          <app-lfsa-input (keypress)="keyDecimals($event)" [control]="this.formulario.get('pesfin')" [id]="'pesfin'"
                          [label]="'Peso Final'"
                          formControlName="pesfin" placeholder="Ej: 1.2345"
                          type="number"></app-lfsa-input>
          <small *ngIf="this.formulario.get('pesfin')?.hasError('pattern')" class="letrasDanger">*Solo números y punto,
            hasta 4 decimales. Ej: 12.3456</small>
        </div>
        <div class="form-group col-12">
          <app-lfsa-input [control]="this.formulario.get('auto')" [id]="'auto'" [label]="'Autorización'"
                          formControlName="auto" type="text"></app-lfsa-input>
        </div>
      </div>
      <div *ngIf="restriccion" class="mt-3 mb-2 text-danger">
        *No se puede duplicar el material y el nivel. Los datos de material y el nivel ya fuerón registrados:
      </div>
      <div *ngIf="restriccion" class="mb-4">
        <table class="w-100 table table-bordered">
          <tr>
            <th>Secuencia</th>
            <th>Material</th>
            <th>Descripción del Material</th>
            <th>Nivel</th>
          </tr>
          <tr>
            <td>{{ restriccionData.id }}</td>
            <td>{{ restriccionData.mate }}</td>
            <td>{{ restriccionData.desmat }}</td>
            <td>{{ restriccionData.nivel }}</td>
          </tr>
        </table>
      </div>
      <app-lfsa-botones-formulario (devolverAccion)="acciones($event)" [formularioValido]="validForm()"
                                   [loading]="loading" [textBoton]="'Guardar'" class="row">
      </app-lfsa-botones-formulario>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->
